import axios from 'axios'
import { SPR_TOKEN } from '@/constant'

// axios配置
axios.defaults.timeout = 5000
axios.defaults.baseURL = process.env.API_HOST

// 请求拦截器
axios.interceptors.request.use((config) => {
  // headers注入ApiKey
  if (process.env.API_KEY) {
    Object.assign(config.headers, {
      ApiKey: process.env.API_KEY,
    })
  }
  // headers注入token
  const jwt = window.localStorage.getItem(SPR_TOKEN)
  if (jwt) {
    Object.assign(config.headers, {
      Authorization: `Bearer ${jwt}`,
    })
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// 响应拦截器
axios.interceptors.response.use((res) => {
  return res
}, (error) => {
  if (error && error.response) {
    const status = error.response.status
    switch (status) {
      case 401:
        console.error('未授权')
        // window.localStorage.removeItem(SPR_TOKEN)
        if (!window.localStorage.getItem('NO_ALERT')) {
          window.localStorage.setItem('NO_ALERT', true)
          alert(error.response.data, function () {
            window.localStorage.removeItem('NO_ALERT')
          })
        }
        window.location.href = '#/login'
        setTimeout(function() {
          window.location.reload()
        })
        break
      default:
        console.error('网络异常', error)
        return Promise.reject(error.response.data)
    }
  }
  return Promise.reject(error)
})

export default {
  install: function (Vue) {
    Vue.$http = axios
    Object.defineProperty(Vue.prototype, '$http', {
      value: axios,
    })
  },
}



// WEBPACK FOOTER //
// ./src/libs/$http.js